import { render, staticRenderFns } from "./LinkSageSupplierPopUp.vue?vue&type=template&id=5d9328de&scoped=true&"
import script from "./LinkSageSupplierPopUp.vue?vue&type=script&lang=js&"
export * from "./LinkSageSupplierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./LinkSageSupplierPopUp.vue?vue&type=style&index=0&id=5d9328de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9328de",
  null
  
)

export default component.exports